const TaxServiceOptions = {
  // *Order matters*
  // self_employed.value and small_business.value are matched by name in
  // backend EmailSubscriptionService (SELF_EMPLOYED_INTEREST_VALUE /
  // SMALL_BUSINESS_INTEREST_VALUE) to detect small-business referral leads.
  // Keep both in sync if these values ever change.
  personal_taxes: { label: 'Personal taxes', value: 'Personal Taxes' },
  self_employed: {
    label: 'Self-employment taxes',
    value: 'Self-Employment Taxes'
  },
  small_business: {
    label: 'Small-business taxes',
    value: 'Small-Business Taxes'
  }
} as const;

export { TaxServiceOptions };
